import React, { forwardRef } from 'react';

/**
 * Bottom connection handle with plus icon
 * Click to add connected node, drag to create connection
 * 
 * Uses --inverse-zoom CSS variable for instant zoom-independent sizing.
 * No React prop needed - CSS handles the scaling directly.
 */
const ConnectionHandle = forwardRef(({ onMouseDown, onClick }, ref) => {
  return (
    <svg 
      ref={ref}
      className="task-node__handle task-node__handle--bottom"
      onMouseDown={onMouseDown}
      onClick={onClick}
      title="Click to add a connected node"
      viewBox="-16 -16 32 32"
      width="32"
      height="32"
      // CSS handles the scaling via --inverse-zoom variable
    >
      {/* Invisible hit area for easier clicking */}
      <circle r="16" fill="transparent" />
      {/* Background circle */}
      <circle
        r="8"
        fill="#1a1a2e"
        stroke="rgba(255, 255, 255, 0.7)"
        strokeWidth="1.5"
        className="task-node__handle-circle"
      />
      {/* Plus sign */}
      <line
        x1="0" y1="-3.5" x2="0" y2="3.5"
        stroke="rgba(255, 255, 255, 0.9)"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="task-node__handle-plus"
      />
      <line
        x1="-3.5" y1="0" x2="3.5" y2="0"
        stroke="rgba(255, 255, 255, 0.9)"
        strokeWidth="1.5"
        strokeLinecap="round"
        className="task-node__handle-plus"
      />
    </svg>
  );
});

ConnectionHandle.displayName = 'ConnectionHandle';

export default ConnectionHandle;

